import React, { useEffect, useState, useRef } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useNavigate } from "react-router-dom";
import { useAppContext, APP_ACTIONS, changeHostIP, WS, userId } from "../../context/appContext";
import CreateMarketConfigModal from "./modals/create-custom-market.";
import fetchUserSettings from "../common/helpers/fetch-user-settings";
import updateUserSettings from "../common/helpers/update-user-settings";
import { CloseOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import fetchUnprocessedOrders from "../common/helpers/fetch-unprocessed-orders";
import createUnprocessedOrders from "../common/helpers/create-unprocessed-orders";
import createUnprocessedAccumulators from "../common/helpers/create-unprocessed-accumulators";
const { Option } = Select;
const { TabPane } = Tabs;

const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }


const CustomMarket = ({ setRestartData }) => {
    const {
        state: { customMarkets },
        dispatch
    } = useAppContext();
    const inputFile = useRef(null) 
    const [displayCreateMarketConfig, setDisplayCreateMarketConfig] = useState(false);
    const [displayDeleteMarketConfig, setDisplayDeleteMarketConfig] = useState(false);
    const [marketConfigList, setMarketConfigList] = useState([]);
    const [selectedMarketConfig, setSelectedMarketConfig] = useState(null);
    const [deleteMarketConfigId, setDeleteMarketConfigId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [backup, setBackup] = useState(false);
    const [fileContent, setFileContent] = useState("");
    const [disableButton, setDisableButton] = useState(false);

        // useEffect(() => {
    //     if(inputFile) {

    //         const files = inputFile.current.files;

    //         console.log({files})
    //         if (files.length <= 0) {
    //           return false;
    //         }

    //         const filesJSON = Array.from(e.target.files)
    //         console.log("files:", filesJSON)
          
    //         // let fr = new FileReader();
          
    //         // fr.onload = function(e) { 
    //         // console.log(e);
    //         //   let result = JSON.parse(e.target.result);
    //         //   let formatted = JSON.stringify(result, null, 2);
    //         //   console.log({formatted})
    //         // }
          
    //     }
    // }, [inputFile])

    const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const readFile = async (event) => {
        try {
            const fileReader = new FileReader();
            const { files } = event.target;
        
            fileReader.readAsText(files[0], "UTF-8");
            fileReader.onload = async (e) => {
                try {
                    const content = e.target.result;
    
                    let parsed = JSON.parse(content);
          
                    if (!parsed) {
                      message.error('Error: File could not be read');
                      setBackup(false);
                    }
      
                    for(const data of parsed) {
          
                      const orders = data.strategies;
                      if (Array.isArray(orders?.data)) {
                          const unProcessedOrders = orders?.data;
                          unProcessedOrders.forEach(order => { delete order.logs; delete order.expanded; delete order.saved; })
                    
                          await createUnprocessedOrders(unProcessedOrders)
                      }
          
                      const accumulators = data.accumulators;
          
                      if (Array.isArray(accumulators?.data)) {
                          const unProcessedOrders = accumulators?.data;
                          unProcessedOrders.forEach(accumulator => { delete accumulator.logs; delete accumulator.expanded; delete accumulator.saved; })
          
                          await createUnprocessedAccumulators(unProcessedOrders)
                      }
                    }
                    setDisableButton(true)
                    message.loading({ content: 'Waiting...', key: 'restore', duration: 0 });
                    await sleep(3*1000)
                    setDisableButton(false)
                    setRestartData(prev => !prev);
                    message.destroy('restore');
                    message.success('Strategies restored');
                    setBackup(false);

                } catch (error) {
                    message.error(error.message);
                }
           

            };
        } catch (error) {
            message.error(error.message);
        }
      };

      const downloadStrategies = async () => {

        try {
            fetchUnprocessedOrders().then(res => {
                if (Array.isArray(res)) {
    
                    // let orders = [];
                    // for (let bot of res) {
                    //     if (bot?.strategies?.data) {
                    //         orders = [...orders, ...bot.strategies.data];
                    //     }
                    // }
    
                    // orders.forEach(order => {
                    //     order.logs = [];
                    //     order.saved = true;
                    //     order.expanded = false;
                    // })
    
                    // let accumulators = [];
                    // for (let bot of res) {
                    //     if (bot?.accumulators?.data) {
                    //         accumulators = [...accumulators, ...bot.accumulators.data];
                    //     }
                    // }
    
                    // accumulators.forEach(order => {
                    //     order.logs = [];
                    //     order.saved = true;
                    //     order.expanded = false;
                    // })
    
                    // create file in browser
                    const fileName = "strategies_backup";
                    const json = JSON.stringify(res, null, 2);
                    const blob = new Blob([json], { type: "application/json" });
                    const href = URL.createObjectURL(blob);
    
                    // create "a" HTLM element with href to file
                    const link = document.createElement("a");
                    link.href = href;
                    link.download = fileName + ".json";
                    document.body.appendChild(link);
                    link.click();
    
                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
    
                }
            })
        } catch (error) {
            message.error(error.message);
        }
     
    }

    const onButtonClick = () => {
        inputFile.current.click();
      };
    // useEffect(() => {
    //     try {
    //         const marketList = localStorage.getItem(`custom_market_config`);
    //         let parsed = JSON.parse(marketList);
    //         dispatch({
    //             type: APP_ACTIONS.SET_CUSTOM_MARKETS,
    //             payload: parsed,
    //         })
    //     } catch (err) {
    //         console.log({ err })
    //     }

    // }, [])



    useEffect(() => {
        try {
            setIsLoading(true);

            if (userId) {
                fetchUserSettings(userId).then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_CUSTOM_MARKETS,
                        payload: res || [],
                    })

                    setIsLoading(false);
                })
            }

        } catch (err) {
            console.log({ err })
        }

    }, [userId])



    const handleDelete = async () => {

        let newCustomMarkets = [...customMarkets]
        newCustomMarkets = newCustomMarkets.filter(x => x.id !== deleteMarketConfigId)

        updateUserSettings({ user_id: userId, data: newCustomMarkets }).then(res => {
            dispatch({
                type: APP_ACTIONS.SET_CUSTOM_MARKETS,
                payload: newCustomMarkets || [],
            })
        })

        setDisplayDeleteMarketConfig(false);
    }

    const handleMarketConfigCreate = async (data, action) => {
        try {
            const { first_asset, second_asset, price } = data;

            let symbol = `${first_asset.toUpperCase()}/${second_asset.toUpperCase()}`
            data.symbol = symbol;

            const marketList = localStorage.getItem(`custom_market_config`);
            let parsed = JSON.parse(marketList);

            let newCustomMarkets = [...customMarkets]

            if (action === 'create') {
                data.id = uuidv4();
                newCustomMarkets.push(data);
            }
            else if (action === 'update') {
                let Index = newCustomMarkets.findIndex(x => x.id == data?.id)
                newCustomMarkets[Index] = data;
            }

            updateUserSettings({ user_id: userId, data: newCustomMarkets }).then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_CUSTOM_MARKETS,
                    payload: newCustomMarkets || [],
                })
            })

            setDisplayCreateMarketConfig(false);
            setSelectedMarketConfig(null);
        } catch (err) {
            message.error(err.message);
        }
    }

    return (
        <>
            {displayCreateMarketConfig && <CreateMarketConfigModal displayCreateMarketConfig={displayCreateMarketConfig} setDisplayCreateMarketConfig={setDisplayCreateMarketConfig} onMarketConfigCreate={handleMarketConfigCreate} selectedMarketConfig={selectedMarketConfig} setSelectedMarketConfig={setSelectedMarketConfig} />}

            <Modal 
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
                visible={backup} footer={null} onCancel={() => { setBackup(false); }}>

                <div style={{ fontWeight: "600", color: "white" }}>Backup or Restore</div>
                <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                   You can download all your strategies or restore strategies from a downloaded backup
                </div>
                <input type='file' onChange={readFile} id='file' ref={inputFile} accept=".json" style={{display: 'none'}}/>
                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button disabled={disableButton} onClick={() => { downloadStrategies() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">DOWNLOAD ALL YOUR STRATEGIES</Button>
                    <Button disabled={disableButton} onClick={() => { onButtonClick() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">RESTORE A BACKUP</Button>
                </div>
            </Modal>

            {displayDeleteMarketConfig &&
                <Modal bodyStyle={{
                    backgroundColor: 'black',
                    border: "1px solid grey"
                }}
                    visible={displayDeleteMarketConfig} footer={null} onCancel={() => { setDisplayDeleteMarketConfig(false); }}>

                    <div style={{ fontWeight: "600", color: "white" }}>Delete Market Config</div>
                    <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                        Are you sure you want to delete this market config?
                    </div>


                    <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                        <Button onClick={() => { setDisplayDeleteMarketConfig(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                        <Button onClick={() => {
                            handleDelete();
                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                    </div>
                </Modal>
            }


            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="66.846" height="66.847" viewBox="0 0 66.846 66.847">
                            <path id="Path_5814" data-name="Path 5814" d="M294.979,160.477H232.83a2.348,2.348,0,0,0-2.349,2.349v62.149a2.349,2.349,0,0,0,2.349,2.349h62.149a2.349,2.349,0,0,0,2.349-2.349V162.826a2.35,2.35,0,0,0-2.35-2.35Zm-2.349,62.151H235.18V165.175h57.45Zm-50.411-4.69h43.375a2.349,2.349,0,0,0,2.349-2.349V200.875a2.349,2.349,0,0,0-2.349-2.349H242.219a2.349,2.349,0,0,0-2.349,2.349v14.715A2.347,2.347,0,0,0,242.219,217.939Zm2.349-14.715h38.677V213.24H244.568Zm-.494-20.7V193.9a2.349,2.349,0,0,0,4.7,0V182.522a6.556,6.556,0,1,0-4.7,0Zm2.35-7.957a1.853,1.853,0,0,1,.036,3.707c-.012,0-.024,0-.035,0s-.024,0-.035,0a1.853,1.853,0,0,1,.034-3.707Zm17.482,21.688a6.544,6.544,0,0,0,2.349-12.657V172.215a2.349,2.349,0,1,0-4.7,0V183.6a6.544,6.544,0,0,0,2.349,12.657Zm0-8.412a1.857,1.857,0,1,1-1.857,1.856A1.859,1.859,0,0,1,263.906,187.841Zm15.131,1.32V193.9a2.349,2.349,0,0,0,4.7,0V189.16a6.527,6.527,0,0,0,0-12.2v-4.742a2.349,2.349,0,0,0-4.7,0v4.743a6.528,6.528,0,0,0,0,12.2Zm2.35-7.957a1.857,1.857,0,1,1-1.854,1.857A1.861,1.861,0,0,1,281.386,181.2Z" transform="translate(-230.482 -160.476)" fill="#fff" opacity="0.5" />
                        </svg>
                        <div>
                            <div style={{ color: "white", fontSize: 17, cursor: "default" }}>Market Config List</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>Create market config and manage their settings.</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>To start click <span style={{ textDecoration: "underline" }}>'CREATE MARKET CONFIG'</span> </div>
                        </div>

                    </div>
                    <div>

                    <Button onClick={() => { setBackup(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50, marginRight: 15 }} type="default">BACKUP/RESTORE</Button>

                        <Button onClick={() => { setDisplayCreateMarketConfig(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50 }} type="default">CREATE MARKET CONFIG</Button>
                    </div>

                </div>
                {isLoading ? <Spin size="large" style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 120

                }} /> :
                    <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                        <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                            <div style={{ maxHeight: 800, overflowY: "auto", }}>
                                <table style={{ width: "100%", }}>
                                    <tr>
                                        <th style={{ ...tableHeaderStyle, width: '40%' }} >MARKET</th>
                                        <th style={{ ...tableHeaderStyle, width: '40%' }} >PRICE</th>
                                        <th style={{ ...tableHeaderStyle, width: '20%' }} >ACTION</th>
                                    </tr>
                                    {Array.isArray(customMarkets) && customMarkets?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))?.map(market => <tr>
                                        <td style={tableRowStyle}>
                                            <div>{market.symbol}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div>{market.price}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>

                                                <span><Button
                                                    onClick={() => { setSelectedMarketConfig(market); setDisplayCreateMarketConfig(true); }}
                                                    style={{ backgroundColor: "#161616", color: "white" }}>Edit</Button></span>
                                                <span><Button
                                                    onClick={() => { setDeleteMarketConfigId(market.id); setDisplayDeleteMarketConfig(true); }}
                                                    style={{ backgroundColor: "#161616", color: "white" }}>Delete</Button></span>
                                            </div>

                                        </td>
                                    </tr>)}

                                </table>
                            </div>
                            {Array.isArray(customMarkets) && customMarkets?.length === 0 && <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                                <div style={{ color: "white" }} >THERE ARE NO CUSTOM MARKET CONFIG HERE.</div>
                                <div style={{ color: "white" }} >START BY CLICKING BELOW</div>
                                <Button onClick={() => { setDisplayCreateMarketConfig(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50, marginTop: 10, }} type="default">CREATE CUSTOM MARKET CONFIG</Button>

                            </div>}
                        </div>
                    </div>
                }

            </div>

        </>
    );
};

export default CustomMarket;